// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"dn-z","badgeLink":"en-z","category":"fn-z"};